import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Close2"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.7269 2.14679L8 6.41982L12.2731 2.14679C12.4538 1.96613 12.738 1.95223 12.9346 2.1051L12.9819 2.14679L13.8532 3.01814C14.0339 3.19881 14.0478 3.48309 13.8949 3.67969L13.8532 3.7269L9.58018 8L13.8532 12.2731C14.0489 12.4688 14.0489 12.7861 13.8532 12.9819L12.9819 13.8532C12.7861 14.0489 12.4688 14.0489 12.2731 13.8532L8 9.58018L3.7269 13.8532C3.54624 14.0339 3.26196 14.0478 3.06536 13.8949L3.01814 13.8532L2.14679 12.9819C1.96613 12.8012 1.95223 12.5169 2.1051 12.3203L2.14679 12.2731L6.41982 8L2.14679 3.7269C1.95107 3.53118 1.95107 3.21386 2.14679 3.01814L3.01814 2.14679C3.21386 1.95107 3.53118 1.95107 3.7269 2.14679Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var close2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { close2 as default };
